import { SOFTWARE } from '../constant/actionTypes';
import { dateFormat } from '../helper/StringUtils';
import { httpservice, httpserviceWithMultipart } from '../services';
import { constants } from '../constant/constant';

const FileSaver = require('file-saver');

let apiEndPoint = constants.ADMIN_URL;
const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;

if (loginUser) {
  if (loginUser.role.roleName === 'client') {
    apiEndPoint = constants.CLIENT_URL;
  }
}

export const getSubmoduleVersionList = (submoduleId, object, setIsPageLoad = null) => (dispatch) => {
  if (setIsPageLoad) {
    setIsPageLoad(true);
  }
  dispatch({
    payload: [],
    type: SOFTWARE.SUBMODULE_VERSION.INITIATE,
  });
  return httpservice()
    .get(`${constants.API.SOFTWARE_SUBMODULE_VERSION}/${submoduleId}`)
    .then((response) => {
      if (setIsPageLoad) {
        setIsPageLoad(false);
      }

      const count = response.data.response ? response.data.response.length : 0;

      const responseData = response.data.response.map((data) => (
        {
          ...data,
          platform: `${data.platform.charAt(0).toUpperCase()}${data.platform.slice(1)}`,
          createdAt: dateFormat(data.createdAt),
          createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
        }
      ));

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: SOFTWARE.SUBMODULE_VERSION.SUCCESS,
      });

      return responseData;
    })
    .catch((error) => {
      if (setIsPageLoad) {
        setIsPageLoad(false);
      }

      dispatch({
        payload: error,
        type: SOFTWARE.SUBMODULE_VERSION.ERROR,
      });

      return error;
    });
};

export const doSubmoduleVersionCreate = (data) => httpserviceWithMultipart('post', data, apiEndPoint + constants.API.SUBMODULE_VERSION);

export const doSubmoduleVersionUpdate = (data, id) => httpserviceWithMultipart('put', data, `${apiEndPoint}${constants.API.SUBMODULE_VERSION}/${id}`);

export const doSubmoduleVersionDelete = (info) => httpservice()
  .delete(`${constants.API.SUBMODULE_VERSION}/${info}`)
  .then((response) => response.data).catch((error) => error.response.data);

export const doSubmoduleVersionDownload = (rowData, directDownload = false) => httpservice()

  .get(
    `${directDownload ? constants.API.DIRECT_DOWNLOAD_SUBMODULE_VERSION : constants.API.DOWNLOAD_SUBMODULE_VERSION}/${rowData.id}`,
    {
      responseType: 'blob',
    },
  )
  .then((response) => {
    console.log(directDownload);
    const blob = new Blob([response.data]);
    FileSaver.saveAs(blob, rowData.releasePath);
    return {};
  })
  .catch((error) => ({ data: error.response, status: 0 }));
